import {useEffect, useRef, useState} from 'react';
import {WdiModalAppProps, WdiCardTitle, wdiCore, WdiInput} from '@/components/WdiControls';
import {ProFormInstance} from '@ant-design/pro-form';
import {WdiSelect, WdiSelectFormat} from '@/components/WdiControls/WdiSelect';
import {Col, DatePicker, DatePickerProps, Form, Input, message, Row, Table, Typography} from 'antd';
import {WdiModalForm} from '@/components/WdiControls/WdiModalForm';
import {ResponseStatus} from '@/utils/request';
import {WdiInputNumber} from '@/components/WdiControls/WdiInputNumber';
import {Product} from '@/services/mdm/product';
import {ShipTo} from '@/services/mdm/shipto';
import moment from 'moment';
import {FormSa} from '@/services/sales/sa';
import DataStore from '@/components/GridWidget/DataStore';
import {WdiTable} from '@/components/WdiControls/WdiTable';
import {WdiPanel} from '@/components/WdiControls/WdiPanel';
import {FormGoodsShipping} from '@/services/sales/sp';
import {SoldTo} from '@/services/mdm/soldto';
import dayjs from "dayjs";
import {freeGoodsProductAjaxDataLoading, freeGoodsProductDataLoading} from "@/pages/sales/sa/components/data";
import {Enum} from "@/enums/system";
import {ProductPrice} from "@/services/mdm/productprice";

const {TextArea} = Input;

interface EditableCellProps extends React.HTMLAttributes<HTMLElement> {
  editing: boolean;
  dataIndex: string;
  title: any;
  record: any;
  index: number;
  children: React.ReactNode;
}


const FormSADetailEditApp: React.FC<WdiModalAppProps> = (props) => {
  const formRef = useRef<ProFormInstance>();

  const [dataSource, setDataSource] = useState<any[]>([]);
  const [formGoodsDetail, setFormGoodsDetail] = useState<API.FormGoodsDetailVo>({});
  const editingFormGoodsDetail = useRef<API.FormGoodsDetailVo>();
  const [editReloadKey, setEditReloadKey] = useState<number>(1);
  const [editingKey, setEditingKey] = useState('');//当前编辑的行
  const [soldTo, setSoldTo] = useState<API.SoldTo>();
  const [shipTo, setShipTo] = useState<API.ShipTo>();

  const isEditing = (record: any) => {
    return record.uid === editingKey
  };

  const edit = (record: Partial<any> & { key: React.Key }) => {
    //重新获取ProductCode、ProductName
    Product.getQueryPo(record.productId).then(response => {
      const newFormGoodsDetail: API.FormGoodsDetailVo = Object.assign(
        record,
        {
          productId: record.productId,
          productCode: response.data?.productCode,
          productName: response.data?.productName,
          uom: response.data?.uom,
          uomName: response.data?.uomName,
          productType: response.data?.productType,
        }
      );

      editingFormGoodsDetail.current = newFormGoodsDetail;
      formRef.current?.setFieldsValue({
        productId: {
          value: newFormGoodsDetail?.productId,
          label: wdiCore.String.CodeOrName(newFormGoodsDetail?.productCode, newFormGoodsDetail?.productName)
        },
        uom: newFormGoodsDetail.uom,
        uomName: newFormGoodsDetail.uomName,
        productType: newFormGoodsDetail.productType,
        unitPrice: newFormGoodsDetail.unitPrice,
        quantity: newFormGoodsDetail.quantity,
        amount: newFormGoodsDetail.amount,
      });
      setEditingKey(record.uid);
      setEditReloadKey(editReloadKey + 1);
    });
  };
  const cancel = () => {
    setEditingKey('');
    editingFormGoodsDetail.current = undefined;
  };
  const save = async (key: React.Key) => {
    if (!validateEditItem()) {
      return false;
    }

    const row = editingFormGoodsDetail.current;
    const newData = [...dataSource];
    const index = newData.findIndex(item => key === item.uid);
    if (index > -1) {
      const item = newData[index];
      newData.splice(index, 1, {
        ...item,
        ...row,
      });
    } else {
      if (row) {
        newData.push(row);
      }
    }
    setDataSource(newData);
    setEditingKey('');
    editingFormGoodsDetail.current = undefined;
    return true;
  }

  const del = (key: any) => {
    if (window.confirm("确认要删除吗")) {
      setDataSource(DataStore.del(dataSource, key));
    }
  };

  const disabledDate: DatePickerProps['disabledDate'] = (current) => {
    return current < dayjs().startOf('day');
  };


  const validateEditItem = () => {
    if (!editingFormGoodsDetail.current?.productId) {
      message.error("产品不能为空");
      return false;
    }
    if (!editingFormGoodsDetail.current?.uom) {
      message.error("领用单位不能为空");
      return false;
    }
    if (!editingFormGoodsDetail.current.quantity || editingFormGoodsDetail.current.quantity <= 0) {
      message.error("申领数量不能为空且必须大于0");
      return false;
    }
    if (!editingFormGoodsDetail.current.unitPrice) {
      message.error(`产品【${editingFormGoodsDetail.current.productCode}】找不到价格`);
      return false;
    }
    if (!editingFormGoodsDetail.current.amount || editingFormGoodsDetail.current.amount <= 0) {
      message.error("申领金额不能为空且必须大于0");
      return false;
    }

    if (dataSource.findIndex(item => {
      return item.productId == editingFormGoodsDetail.current?.productId && item.uid != editingKey
    }) >= 0) {
      message.error(`申领产品【${wdiCore.String.CodeOrName(editingFormGoodsDetail.current?.productCode, editingFormGoodsDetail.current?.productName)} 】已申领，请检查`);
      return false;
    }
    return true;
  }

  const validateItem = () => {
    if (!formGoodsDetail) {
      message.error("产品不能为空");
      return false;
    }
    if (!formGoodsDetail.productId) {
      message.error("产品不能为空");
      return false;
    }
    if (!formGoodsDetail.uom) {
      message.error("领用单位不能为空");
      return false;
    }
    if (!formGoodsDetail.quantity || formGoodsDetail.quantity <= 0) {
      message.error("申领数量不能为空且必须大于0");
      return false;
    }
    if (!formGoodsDetail.unitPrice) {
      message.error(`产品【${formGoodsDetail.productCode} 】找不到价格`);
      return false;
    }
    if (!formGoodsDetail.amount || formGoodsDetail.amount <= 0) {
      message.error("申领金额不能为空且必须大于0");
      return false;
    }

    if (dataSource.findIndex(item => item.productId == formGoodsDetail.productId) >= 0) {
      message.error(`申领产品【${wdiCore.String.CodeOrName(formGoodsDetail.productCode, formGoodsDetail.productName)} 】已申领，请检查`);
      return false;
    }

    return true;
  }
  const addItem = () => {
    if (validateItem()) {
      setDataSource(DataStore.add(dataSource, formGoodsDetail));
      setFormGoodsDetail({});
    }
  }

  const columns = [
    {
      title: '产品',
      dataIndex: 'productId',
      width: 300,
      editable: true,
      ellipsis: true,
      render: (value: any, record: any) => {
        return wdiCore.String.CodeOrName(record.productCode, record.productName);
      }
    },
    {
      title: '领用单位',
      dataIndex: 'uomName',
      editable: true,
      ellipsis: true,
    },
    // {
    //   title: '申领单价',
    //   dataIndex: 'unitPrice',
    //   editable: true,
    //   render: (value: any, record: any) => {
    //     return wdiCore.Number.AmountToString(value);
    //   }
    // },
    {
      title: '申领数量',
      dataIndex: 'quantity',
      editable: true,
      ellipsis: true,
      render: (value: any, record: any) => {
        return value;
      }
    },
    {
      title: '申领金额',
      dataIndex: 'amount',
      editable: true,
      ellipsis: true,
      render: (value: any, record: any) => {
        return wdiCore.Number.AmountToString(value);
      }
    },
    {
      title: '操作',
      dataIndex: 'operation',
      width: 80,
      render: (_: any, record: any) => {
        const editable = isEditing(record);

        return editable ? (
          <>
            <Typography.Link onClick={() => save(record.uid)} style={{marginRight: 8}}>
              更新
            </Typography.Link>
            <Typography.Link onClick={() => cancel()}>
              取消
            </Typography.Link>
          </>
        ) : (
          <>
            <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)} style={{marginRight: 8}}>
              编辑
            </Typography.Link>
            <Typography.Link onClick={() => del(record.uid)}>
              删除
            </Typography.Link>
          </>)
      }
    },
  ];

  const mergedColumns = columns.map(col => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record: any) => ({
        record,
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  const EditableCell: React.FC<EditableCellProps> = ({
                                                       editing,
                                                       dataIndex,
                                                       title,
                                                       record,
                                                       index,
                                                       children,
                                                       ...restProps
                                                     }) => {
    let inputNode = children;
    if (dataIndex == 'productId') {
      inputNode = <WdiSelect
        placeholder="请录入或选择"
        showSearch={true}
        remote={true}
        labelInValue={true}
        style={{width: '100%'}}
        onChange={async (value, option) => {
          const productId = WdiSelectFormat.getvalue(value);
          const newFormGoodsDetail = await getFormGoodsDetail(shipTo, productId, editingFormGoodsDetail.current);
          editingFormGoodsDetail.current = newFormGoodsDetail;
          setEditReloadKey(editReloadKey + 1);
        }}
        //（不过滤productType）第5层&当前BU下&激活的&（上面所选的费用品牌下 or 产品的父级为空的）&当前客户的公司关联的(用soldto的companycode过滤productAndCompany)；单选/必填，值改变后调用自动赋值方法
        // 新建 编辑 导入 不校验公司和产品的关联关系 仅提交单据校验
        dataLoading={(params) => freeGoodsProductAjaxDataLoading(
          Object.assign({
            productLevels: [Enum.ProductLevel.PRODUCT5].join(','),
            isActive: true,
            withNullOrAncestor: true,
            productTypes: [Enum.ProductType.FINISHED, Enum.ProductType.NON_FINISHED].join(',')
          }, params)
        )}
      />;
    } else if (dataIndex == 'quantity') {
      inputNode = <WdiInputNumber digits={5}
                                  onBlur={(e: any) => {
                                    const newFormGoodsDetail = {...editingFormGoodsDetail.current};
                                    newFormGoodsDetail.quantity = wdiCore.Number.ToNumber(e.target?.value, 5);
                                    newFormGoodsDetail.amount = getAmount(newFormGoodsDetail.quantity, newFormGoodsDetail.unitPrice);
                                    editingFormGoodsDetail.current = newFormGoodsDetail;
                                    setEditReloadKey(editReloadKey + 1);
                                  }}
      />;
    } else if (
      // dataIndex == 'unitPrice' ||
      dataIndex == 'amount' ||
      dataIndex == 'uom'
    ) {
      inputNode = <>
        {editReloadKey
          && <Input value={editingFormGoodsDetail?.current?.[dataIndex]}
                    style={{background: 'none', border: 'none'}}
                    readOnly
          />
        }
      </>
    }

    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{margin: 0}}
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  const getAmount = (quantity?: number, unitPrice?: number) => {
    if (wdiCore.Object.IsNullOrUndefined(quantity) || wdiCore.Object.IsNullOrUndefined(unitPrice)) {
      return undefined;
    }
    const innerQuantity = quantity ?? 0
    const innerUnitPrice = unitPrice ?? 0
    return wdiCore.Number.ToNumber(innerQuantity * innerUnitPrice, 2);
  }

  const getFormGoodsDetail = async (shipTo?: API.ShipTo, productId?: any, detail?: API.FormGoodsDetailVo) => {
    let product;
    let productPriceFg;
    if (productId) {
      const productResponse = await Product.getQueryPo(productId);
      product = productResponse?.data;
      const productPriceFgRes = await ProductPrice.getProductPriceFg({
        productId: productId,
        shipToCode: shipTo?.shipToCode
      })
      productPriceFg = productPriceFgRes?.data
    }
    if (product && wdiCore.Object.IsNullOrUndefined(productPriceFg?.priceInVat) && shipTo) {
      message.error(`产品【${product.codeOrName}】找不到免费货固定价`);
    }else if(!shipTo && detail == formGoodsDetail){
      product = null;
      productPriceFg = null;
      message.error("请先选择收货地");
    }
    const newFormGoodsDetail: API.FormGoodsDetailVo = {
      quantity: detail?.quantity,
      productId: product?.productId,
      productCode: product?.productCode,
      productName: product?.productName,
      uom: product?.uom,
      uomName: product?.uomName,
      productType: product?.productType,
      unitPrice: productPriceFg?.priceInVat,
      amount: getAmount(detail?.quantity, productPriceFg?.priceInVat),
      uid: detail?.uid
    };
    return newFormGoodsDetail;
  }


  useEffect(() => {
    if (props.data.formSaDetail) {
      const detail = props.data.formSaDetail;
      formRef.current?.setFieldsValue({
        formSaDetailId: detail.formSaDetailId,
        rowNumber: detail.rowNumber,
        boId: detail.boId,
        ecId: detail.ecId,
        boName: detail.boName,
        ecName: detail.ecName,
        soldToCode: detail.soldToCode,
        soldToName: wdiCore.String.CodeOrName(detail.soldToCode, detail.soldToName),
        shipToCode: detail.shipToCode,
        brandId: detail.brandId,
        expectDeliveryDate: detail?.expectDeliveryDate ? moment(String(detail?.expectDeliveryDate), "YYYY-MM-DD") : null,
        expectArrivalDate: detail?.expectArrivalDate ? moment(String(detail?.expectArrivalDate), "YYYY-MM-DD") : null,
        remark: detail.remark,
        address: detail.address,
        contactsName: detail.contactsName,
        contactsTel: detail.contactsTel
      });


      if (detail?.soldToCode) {
        SoldTo.get(detail.soldToCode).then(responseResult => {
          setSoldTo(responseResult.data);
          formRef.current?.setFieldsValue({
            soldToName: responseResult.data.codeOrName,
          });
        })
      }
      if (detail?.shipToCode) {
        ShipTo.get(detail.shipToCode).then(res => {
          const innerShipTo = res?.data;
          setShipTo(innerShipTo);
          formRef.current?.setFieldsValue({
            address: innerShipTo?.address,
            shipToCode: {value: innerShipTo?.shipToCode, label: wdiCore.String.Join(innerShipTo?.codeOrName, innerShipTo?.address)}
          })
        })
      }

      if (props.data.formSaDetail.formGoodsDetails) {
        setDataSource(DataStore.init(props.data.formSaDetail.formGoodsDetails));
      }

    }
  }, [props.data.formSaDetail]);

  const refreshFreeGoodsDetail = (shipTo?: API.ShipTo) => {
    (async () => {
      let dataSourceTemp = (dataSource ?? []).concat([]);
      for (let i = 0; i < dataSourceTemp.length; i++) {
        const item = dataSourceTemp[i];
        const detail = await getFormGoodsDetail(shipTo,item.productId, item);
        dataSourceTemp = DataStore.edit(dataSourceTemp, detail);
      }
      if (editingFormGoodsDetail?.current?.productId) {
        editingFormGoodsDetail.current = await getFormGoodsDetail(shipTo, editingFormGoodsDetail?.current?.productId, editingFormGoodsDetail?.current)
        setEditReloadKey(editReloadKey + 1);
      }
      setDataSource(dataSourceTemp)
      if (formGoodsDetail?.productId) {
        const fgDetailTmp = await getFormGoodsDetail(shipTo, formGoodsDetail?.productId, formGoodsDetail);
        setFormGoodsDetail(fgDetailTmp)
      }
    })()
  }

  return (
    <WdiModalForm
      formRef={formRef}
      labelAlign='left'
      layout="vertical"
      title={props.title}
      visible={props.visible}
      modalProps={{
        width: 1000,
        onCancel: () => {
          props.onClose ? props.onClose() : null
        },
        destroyOnClose: true,
        maskClosable: false
      }}
      onFinish={async (values) => {
        const {deliveryLineCode, ...entity} = values;

        let formGoodsDetails = [...dataSource];
        if (formGoodsDetail && formGoodsDetail.productId) {
          if (!validateItem()) {
            return;
          }
          formGoodsDetails = DataStore.add(dataSource, formGoodsDetail);
        }

        if (editingFormGoodsDetail.current && editingFormGoodsDetail.current.productId) {
          if (!validateEditItem()) {
            return;
          }
          formGoodsDetails = DataStore.edit(dataSource, editingFormGoodsDetail.current);
        }

        entity.expectDeliveryDate = wdiCore.Date.DateToString(entity.expectDeliveryDate);
        entity.expectArrivalDate = wdiCore.Date.DateToString(entity.expectArrivalDate);
        entity.shipToCode = WdiSelectFormat.getvalue(values.shipToCode);
        entity.brandId = WdiSelectFormat.getvalue(values.brandId);

        if (!formGoodsDetails || formGoodsDetails.length <= 0) {
          message.error("请填写申领明细！");
          return;
        }

        entity.formGoodsDetails = formGoodsDetails;

        const response = await FormSa.Buttons.validateDetail({
          rowIndex: props.data.rowIndex,
          formSa: {
            pageTypeId: props.data.formSa.pageTypeId,
            budgetProjectId: props.data.formSa.budgetProjectId
          },
          ecId: props.data.ecId,
          formSaDetail: entity,
          formSaDetails: props.data.formSaDetails
        });
        if (response.code !== ResponseStatus.SUCCESS) {
          message.error(response.message);
          return;
        }
        if (props.onSave) {
          props.onSave(response);
        }
      }}
    >
      <Form.Item name="formSaDetailId" label="formSaDetailId" hidden>
        <Input/>
      </Form.Item>
      <Form.Item name="rowNumber" label="rowNumber" hidden>
        <Input/>
      </Form.Item>
      <Form.Item name="ecId" label="ecId" hidden>
        <Input/>
      </Form.Item>
      <Row gutter={[10, 0]}>
        <Col className="gutter-row" span={6}>
          <Form.Item
            label="soldToCode"
            name="soldToCode"
            hidden>
            <Input readOnly/>
          </Form.Item>
          <Form.Item
            label="客户"
            name="soldToName">
            <WdiInput readOnly/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={6}>
          <Form.Item
            label="收货地"
            name="shipToCode"
            rules={[{required: true, message: '收货地不能为空!'}]}>
            <WdiSelect {...{
              placeholder: "请选择收货地",
              defaultParamKey: "shipToCodes",
              remote: true,
              showSearch: true,
              labelInValue: true,
              dataLoading: async (params) => {
                const responseResult = await ShipTo.ajaxSearch(Object.assign({
                  soldToCode: props.data.formSaDetail.soldToCode,
                  withPermissions: true,
                  isActive: true,
                  isFilterValueAddress: true
                }, params));
                if (responseResult?.data?.length == 1) {
                  formRef.current?.setFieldsValue({
                    shipToCode: responseResult.data[0].shipToCode,
                    address: responseResult.data[0].address
                  })
                  setShipTo(responseResult.data[0])
                }
                return (responseResult?.data??[]).map((item) => {
                  return {value: item.shipToCode, label: wdiCore.String.Join(item.codeOrName, item.address)};
                });
              },
              onChange: async (value) => {
                const shipToCode = WdiSelectFormat.getvalue(value);
                const res = await ShipTo.get(shipToCode);
                const shipTo = res?.data;
                setShipTo(shipTo);
                formRef.current?.setFieldsValue({
                  address: shipTo?.address,
                  shipToCode: shipTo ? {
                    label: wdiCore.String.CodeOrName(shipTo.codeOrName, shipTo.address),
                    value: shipTo.shipToCode
                  } : undefined,
                })
                refreshFreeGoodsDetail(shipTo);
              }
            }}
            />
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={6}>
          <Form.Item
            label="要求出库日期"
            name="expectDeliveryDate"
            rules={[{required: true, message: '要求出库日期不能为空!'}]}
          >
            <DatePicker picker={"date"} format={"YYYY-MM-DD"}
                        disabledDate={disabledDate}/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={6}>
          <Form.Item
            label="要求到货日期"
            name="expectArrivalDate"
            rules={[{required: true, message: '要求到货日期不能为空!'}]}>
            <DatePicker picker={"date"} format={"YYYY-MM-DD"}
                        disabledDate={disabledDate}/>
          </Form.Item>
        </Col>


      </Row>
      <Row gutter={[10, 0]}>
        <Col className="gutter-row" span={6}>
          <Form.Item
            label="费用品牌"
            name="brandId"
            rules={[{required: true, message: '费用品牌不能为空!'}]}
          >
            <WdiSelect
              placeholder="请录入或选择"
              showSearch={true}
              value={formGoodsDetail?.productId}
              style={{width: '100%'}}
              reloadKey={soldTo?.soldToCode}
              // 可选为 产品第1层&激活&用户关联的品牌&本专项分配明细中品牌所涉及的，只有一个则默认选中
              dataLoading={async (params) => {
                const labelValueArr = await freeGoodsProductDataLoading(
                  Object.assign({
                    productLevels: [Enum.ProductLevel.PRODUCT1].join(','),
                    budgetProjectId: props.data?.formSa?.budgetProjectId,
                    isActive: true,
                    withPermissions: true,
                    productTypes: [Enum.ProductType.FINISHED].join(',')
                  }, params)
                )
                return labelValueArr;
              }}
            />
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={6}>
          <Form.Item
            label="备注"
            name="remark">
            <TextArea rows={1} style={{width: '100%'}} maxLength={2000}/>
          </Form.Item>
        </Col>

        <Col className="gutter-row" span={6}>
          <Form.Item
            label="boId"
            name="boId"
            hidden>
            <Input readOnly/>
          </Form.Item>
          <Form.Item
            label="四级使用部门"
            name="boName">
            <WdiInput readOnly/>
          </Form.Item>
        </Col>

        <Form.Item
          label="ecId"
          name="ecId"
          hidden>
          <Input readOnly/>
        </Form.Item>
        <Col className="gutter-row" span={6}>
          <Form.Item label="费用项" name="ecName">
            <WdiInput readOnly/>
          </Form.Item>
        </Col>

        <Col className="gutter-row" span={6}>
          <Form.Item
            label="地址"
            name="address">
            <WdiInput readOnly/>
          </Form.Item>
        </Col>
      </Row>
      <WdiPanel title={<WdiCardTitle title='申领明细'/>}>
        <WdiTable
          components={{
            body: {
              cell: EditableCell,
            },
          }}
          columns={mergedColumns}
          rowKey="uid"
          dataSource={dataSource}
          pagination={false}
          aggrColumns={['amount']}
          extraFooterSummary={() => {
            return (<Table.Summary.Row>
              <Table.Summary.Cell index={0}>
                <WdiSelect
                  placeholder="请录入或选择"
                  showSearch={true}
                  remote={true}
                  value={{
                    label: wdiCore.String.CodeOrName(formGoodsDetail?.productCode, formGoodsDetail?.productName),
                    value: formGoodsDetail?.productId
                  }}
                  style={{width: '100%'}}
                  onChange={async (value, option) => {
                    const productId = WdiSelectFormat.getvalue(value);
                    const newFormGoodsDetail = await getFormGoodsDetail(shipTo,productId, formGoodsDetail);
                    setFormGoodsDetail(newFormGoodsDetail)
                  }}
                  //（不过滤productType）第5层&当前BU下&激活的&（上面所选的费用品牌下 or 产品的父级为空的）&当前客户的公司关联的(用soldto的companycode过滤productAndCompany)；单选/必填，值改变后调用自动赋值方法
                  // 新建 编辑 导入 不校验公司和产品的关联关系 仅提交单据校验
                  dataLoading={(params) => freeGoodsProductAjaxDataLoading(
                    Object.assign({
                      productLevels: [Enum.ProductLevel.PRODUCT5].join(','),
                      isActive: true,
                      withNullOrAncestor: true,
                      productTypes: [Enum.ProductType.FINISHED, Enum.ProductType.NON_FINISHED].join(',')
                    }, params)
                  )}
                />
              </Table.Summary.Cell>
              <Table.Summary.Cell index={1}>
                {formGoodsDetail?.uomName}
              </Table.Summary.Cell>
              {/*<Table.Summary.Cell index={3}>*/}
              {/*  {formGoodsDetail?.unitPrice}*/}
              {/*</Table.Summary.Cell>*/}
              <Table.Summary.Cell index={3}>
                <WdiInputNumber
                  digits={5}
                  value={formGoodsDetail?.quantity}
                  onBlur={async (e: any) => {
                    formGoodsDetail.quantity = wdiCore.Number.ToNumber(e.target.value, 5)
                    formGoodsDetail.amount = getAmount(formGoodsDetail?.quantity, formGoodsDetail?.unitPrice);
                    setFormGoodsDetail({...formGoodsDetail})
                  }}
                />
              </Table.Summary.Cell>
              <Table.Summary.Cell index={5}>
                {formGoodsDetail?.amount}
              </Table.Summary.Cell>
              <Table.Summary.Cell index={6}>
                <Typography.Link onClick={() => addItem()}>
                  新增
                </Typography.Link>
              </Table.Summary.Cell>
            </Table.Summary.Row>)
          }}
        />
      </WdiPanel>
    </WdiModalForm>
  );
}
export default FormSADetailEditApp;

type FormSADetailViewAppProps = {
  form?: API.Form
} & WdiModalAppProps

export const FormSADetailViewApp: React.FC<FormSADetailViewAppProps> = (props) => {

  const formRef = useRef<ProFormInstance>();

  const [dataSource, setDataSource] = useState<API.FormGoodsDetailVo[]>([]);
  const [shippingDataSource, setShippingDataSource] = useState<API.FormGoodsDetailVo[]>([]);

  const columns = [
    {
      title: '申领明细ID',
      dataIndex: 'formGoodsDetailId',
      width: 300,
      ellipsis: true,
      render: (value: any, record: any) => {
        return [props.form?.formNo, record?.formSaDetailId, record?.formGoodsDetailId].join('-')
      }
    },
    {
      title: '申领产品',
      dataIndex: 'productId',
      width: 300,
      ellipsis: true,
      render: (value: any, record: any) => {
        return wdiCore.String.CodeOrName(record.productCode, record.productName);
      }
    },
    {
      title: 'IP',
      dataIndex: 'ip',
      ellipsis: true,
    },
    {
      title: '领用单位',
      dataIndex: 'uomName',
      ellipsis: true,
    },
    // {
    //   title: '申领单价',
    //   dataIndex: 'unitPrice',
    //   ellipsis: true,
    //   render: (value: any, record: any) => {
    //     return wdiCore.Number.AmountToString(value);
    //   }
    // },
    {
      title: '申领数量',
      dataIndex: 'quantity',
      ellipsis: true,
      render: (value: any, record: any) => {
        return value;
      }
    },
    {
      title: '申领金额',
      dataIndex: 'amount',
      ellipsis: true,
      render: (value: any, record: any) => {
        return wdiCore.Number.AmountToString(value);
      }
    },
  ];

  const shippingColumns = [
    {
      title: '订单编号',
      dataIndex: 'orderNo',
      width: 120,
      ellipsis: true
    },
    {
      title: '产品',
      dataIndex: 'productId',
      width: 200,
      ellipsis: true,
      render: (value: any, record: any) => {
        return wdiCore.String.CodeOrName(record.productCode, record.productName);
      }
    },
    {
      title: '发货日期',
      dataIndex: 'billingDate',
      width: 120,
      ellipsis: true,
      render: (value: any, record: any) => {
        return wdiCore.Date.DateToString(value);
      }
    },
    {
      title: '发货单位',
      dataIndex: 'uomName',
      width: 100,
      ellipsis: true,
    },
    // {
    //   title: '单价',
    //   dataIndex: 'unitPrice',
    //   width: 100,
    //   ellipsis: true,
    //   render: (value: any, record: any) => {
    //     return wdiCore.Number.AmountToString(value);
    //   }
    // },
    {
      title: '发货数量',
      dataIndex: 'quantity',
      width: 100,
      ellipsis: true
    },
    {
      title: '发货金额',
      dataIndex: 'amount',
      width: 100,
      ellipsis: true,
      render: (value: any, record: any) => {
        return wdiCore.Number.AmountToString(value);
      }
    },
  ];

  useEffect(() => {
    if (props.data) {
      const formSaDetail: API.FormSaDetailVo = props.data;

      formRef.current?.setFieldsValue({
        soldToCode: wdiCore.String.CodeOrName(formSaDetail.soldToCode, formSaDetail.soldToName),
        shipToCode: wdiCore.String.CodeOrName(formSaDetail.shipToCode, formSaDetail.shipToName),
        expectDeliveryDate: wdiCore.Date.DateToString(formSaDetail?.expectDeliveryDate),
        expectArrivalDate: wdiCore.Date.DateToString(formSaDetail?.expectArrivalDate),
        deliveredOperator: wdiCore.Object.IsNullOrUndefined(formSaDetail.deliveredOperator) && formSaDetail.isDelivered ? '系统' : formSaDetail.deliveredOperator,
        remark: formSaDetail.remark,
        deliveredSetupDate: wdiCore.Date.DateToString(formSaDetail?.deliveredSetupDate),
        address: formSaDetail.address,
        brandName: formSaDetail.brandName,
        boName: formSaDetail.boName,
        ecName: formSaDetail.ecName
      });

      if (formSaDetail.formGoodsDetails) {
        setDataSource(formSaDetail.formGoodsDetails);
      }
      FormGoodsShipping.getFormGoodsShippings(formSaDetail.formSaDetailId ?? 0).then(response => {
        setShippingDataSource(DataStore.init(response.data));
      })
    }
  }, [props.data]);

  return (
    <WdiModalForm
      formRef={formRef}
      labelAlign='left'
      layout="vertical"
      title={props.title}
      visible={props.visible}
      submitter={false}
      modalProps={{
        width: 1000,
        onCancel: () => {
          props.onClose ? props.onClose() : null
        },
        destroyOnClose: true,
        maskClosable: false
      }}
    >
      <Row gutter={[10, 0]}>
        <Col className="gutter-row" span={6}>
          <Form.Item label="客户" name="soldToCode">
            <WdiInput readOnly/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={6}>
          <Form.Item label="收货地" name="shipToCode">
            <WdiInput readOnly/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={6}>
          <Form.Item label="要求出库日期" name="expectDeliveryDate">
            <WdiInput readOnly/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={6}>
          <Form.Item label="要求到货日期" name="expectArrivalDate">
            <WdiInput readOnly/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={6}>
          <Form.Item label="费用品牌" name="brandName">
            <WdiInput readOnly/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={6}>
          <Form.Item label="备注" name="remark">
            <WdiInput readOnly/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={6}>
          <Form.Item label="四级使用部门" name="boName">
            <WdiInput readOnly/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={6}>
          <Form.Item label="费用项" name="ecName">
            <WdiInput readOnly/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={6}>
          <Form.Item
            label="地址"
            name="address">
            <WdiInput readOnly/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={6}>
          <Form.Item label="发货完成设置人" name="deliveredOperator">
            <WdiInput readOnly/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={6}>
          <Form.Item label="发货完成设置时间" name="deliveredSetupDate">
            <WdiInput readOnly/>
          </Form.Item>
        </Col>
      </Row>
      <WdiPanel title={<WdiCardTitle title='申领明细'/>}>
        <WdiTable
          columns={columns}
          rowKey="uid"
          dataSource={dataSource}
          pagination={false}
          aggrColumns={['amount']}
        />
      </WdiPanel>
      <WdiPanel title={<WdiCardTitle title='发货明细'/>}>
        <WdiTable
          columns={shippingColumns}
          rowKey="uid"
          dataSource={shippingDataSource}
          pagination={false}
          aggrColumns={['amount']}
        />
      </WdiPanel>
    </WdiModalForm>
  );
}
